let sentryEnabled = false;

export function toggleSentry(enabled: boolean): void {
	sentryEnabled = enabled;
}

export function isSentryEnabled(): boolean {
	return sentryEnabled;
}
